import { jsx as a } from "react/jsx-runtime";
import { c as o } from "./index-CYpVUGdk.js";
import { forwardRef as s } from "react";
import { $ as i } from "./utils-CTvPli9r.js";
const d = o(
  "relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), n = s(
  ({ className: t, variant: e, ...r }, l) => /* @__PURE__ */ a("div", { ref: l, role: "alert", className: i(d({ variant: e }), t), ...r })
);
n.displayName = "Alert";
const v = s(
  ({ className: t, ...e }, r) => /* @__PURE__ */ a("h5", { ref: r, className: i("mb-1 font-medium leading-none tracking-tight", t), ...e })
);
v.displayName = "AlertTitle";
const m = s(
  ({ className: t, ...e }, r) => /* @__PURE__ */ a("div", { ref: r, className: i("text-sm [&_p]:leading-relaxed", t), ...e })
);
m.displayName = "AlertDescription";
export {
  n as Alert,
  m as AlertDescription,
  v as AlertTitle
};
//# sourceMappingURL=alert.js.map
